var map = {
	"./blue.png": 534,
	"./green.png": 1026,
	"./grey.png": 5633,
	"./heart.png": 5053,
	"./orange.png": 8057,
	"./pink.png": 4254,
	"./purple.png": 1301,
	"./red.png": 8947,
	"./turquoise.png": 7988,
	"./violet.png": 7554,
	"./yellow.png": 9950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8428;